import React, { useMemo } from "react";

const CollapseOpenIcon = () => {
  const svgContent = useMemo(() => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="81"
        height="16.5"
        viewBox="0 0 81 16.5"
      >
        <g
          id="Group_31203"
          data-name="Group 31203"
          transform="translate(-923.5 -76)"
        >
          <path
            id="Rectangle_15103"
            data-name="Rectangle 15103"
            d="M0,0H81a0,0,0,0,1,0,0V1.5a15,15,0,0,1-15,15H15A15,15,0,0,1,0,1.5V0A0,0,0,0,1,0,0Z"
            transform="translate(923.5 76)"
            fill="#9a9a9a"
          />
          <path
            id="Polygon_11"
            data-name="Polygon 11"
            d="M5.5,0,11,7H0Z"
            transform="translate(969.5 86.75) rotate(180)"
            fill="#fff"
          />
        </g>
      </svg>
    );
  });

  return svgContent;
};

export default CollapseOpenIcon;



// WEBPACK FOOTER //
// ./src/assets/CollapseOpenIcon.jsx